"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Navbar = _interopRequireDefault(require("react-bootstrap/Navbar"));
var _ErrorBoundary = _interopRequireDefault(require("../ErrorBoundary"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class SecondTierBoundary extends _ErrorBoundary.default {
  constructor(props) {
    super(props);
  }
  render() {
    /* istanbul ignore else */
    if (this.state.hasError) {
      return;
    }
    const classDiv = document.createElement('div');
    classDiv.classList.add('main', 'second-tier');
    if (this.props.simple) {
      classDiv.classList.add('simple');
    }
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/aria-role
      _react.default.createElement(_Navbar.default, {
        as: "div",
        className: classDiv.classList.value,
        expand: "lg",
        role: "",
        variant: "dark"
      }, this.props.children)
    );
  }
}
SecondTierBoundary.propTypes = {
  simple: _propTypes.default.bool
};
var _default = exports.default = SecondTierBoundary;